export type ComicPanelRole =
  | 'introduction'
  | 'key_fact'
  | 'explanation'
  | 'conclusion';

export type CharacterPose = 'welcome' | 'explain' | 'emphasize' | 'conclude';

export interface ComicPanel {
  role: ComicPanelRole;
  text: string;
  visualDescription: string;
  characterPose: CharacterPose;
}

export interface ComicStoryboard {
  title: string;
  sourceSummary: string;
  panels: ComicPanel[];
  sourceFidelityScore?: number | null;
  accuracyScore?: number | null;
  languageScore?: number | null;
}

export const EMPTY_STORYBOARD: ComicStoryboard = {
  title: '',
  sourceSummary: '',
  panels: [
    {
      role: 'introduction',
      text: '',
      visualDescription: '',
      characterPose: 'welcome',
    },
    {
      role: 'key_fact',
      text: '',
      visualDescription: '',
      characterPose: 'explain',
    },
    {
      role: 'explanation',
      text: '',
      visualDescription: '',
      characterPose: 'emphasize',
    },
    {
      role: 'conclusion',
      text: '',
      visualDescription: '',
      characterPose: 'conclude',
    },
  ],
};
